import { useCallback, useEffect, useState } from "react";
import api from "../api/client";
import { INBOX_CHANGED_EVENT, inboxApiPaths } from "../utils/notificationInbox";

export default function useInboxUnreadCount(role, enabled = true) {
  const [unreadCount, setUnreadCount] = useState(0);
  const [chatUnreadCount, setChatUnreadCount] = useState(0);

  const refresh = useCallback(async () => {
    if (!enabled || !role) return;
    try {
      const { unread } = inboxApiPaths(role);
      const res = await api.get(unread);
      const count = res.data?.data?.unreadCount;
      const chatCount = res.data?.data?.chatUnreadCount;
      if (count != null) setUnreadCount(Number(count) || 0);
      setChatUnreadCount(Number(chatCount) || 0);
    } catch {
      /* keep last known count */
    }
  }, [enabled, role]);

  useEffect(() => {
    if (!enabled) {
      setUnreadCount(0);
      setChatUnreadCount(0);
      return undefined;
    }
    refresh();
    const onChanged = () => {
      refresh();
    };
    const onVisible = () => {
      if (document.visibilityState === "visible") refresh();
    };
    window.addEventListener(INBOX_CHANGED_EVENT, onChanged);
    document.addEventListener("visibilitychange", onVisible);
    const id = setInterval(refresh, 30000);
    return () => {
      window.removeEventListener(INBOX_CHANGED_EVENT, onChanged);
      document.removeEventListener("visibilitychange", onVisible);
      clearInterval(id);
    };
  }, [enabled, refresh]);

  return { unreadCount, chatUnreadCount, refresh, setUnreadCount };
}
